<!-- Sticky mobile -->
@if (!isCartEmpty && isMobileMQ) {
    <checkout-sticky
        [showDaily]="showDaily"
        [showMonthly]="showMonthly"
        [prices]="{
            DAILY: commercialProposal?.initialAmount || totals.daily.final,
            MONTHLY: totals.monthly.final,
        }"
        [noButtons]="noButtons"
        [formData]="formStatus$ | async"
        [edpTicketLine]="edpTicketLine"
        [fundingPrice]="commercialProposal?.monthlyAmount || edpTicketLine?.price"
        (validateEvent)="validate()"
        (scrollEvent)="receiveScroll()"
    />
}
<div
    class="box min-h-25 is-justified-center"
    id="ticket"
    checkoutScrollTo
    [enableScroll]="isMobileMQ && scrollToTicket"
    domId="checkout-ticket"
>
    <div class="box-content">
        @if (!isCartEmpty) {
            <p class="has-text-left is-size-3 has-text-weight-bold">Mes achats</p>
            <div class="divider is-unboxed has-background-info-fade"></div>
            <!------------------------------------------------ DAILY ------------------------------------------------>
            @if (showDaily) {
                <div checkoutCy="cart_daily" class="rows has-gap-3">
                    <checkout-ticketline
                        [isTitle]="true"
                        label="À payer aujourd'hui"
                        [showPrice]="true"
                        [priceCheckoutCy]="'today_price'"
                        [totalPrice]="commercialProposal?.initialAmount || totals.daily.final"
                    />
                    <div checkoutCy="price_details_ticket">
                        <div class="rows has-gap-2">
                            @for (ticketLine of ticketLines | productLineType: 'daily' : true; track ticketLine) {
                                @if (!ticketLine.isIncludedPrice) {
                                    <checkout-ticketline
                                        [ticketLine]="ticketLine"
                                        [showPrice]="ticketLine.price > 0 && !commercialProposal?.nbLoan"
                                        [dataTcCategory]="ticketLine?.popover ? 'Cle_4G' : ''"
                                        [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                        labelCheckoutCy="today_ticket_label"
                                    />
                                }
                            }
                            <!-- Coupon -->
                            @for (coupon of ticketLines | productLineType: 'coupon'; track coupon) {
                                <checkout-ticketline
                                    [ticketLine]="coupon"
                                    [showPrice]="coupon.price"
                                    priceCheckoutCy="coupon_amount"
                                    labelCheckoutCy="coupon_label"
                                />
                            }
                            <!-- ODR -->
                            @if (refundAmount > 0) {
                                <checkout-ticketline
                                    label="Remboursement après achat"
                                    [showPrice]="true"
                                    [totalPrice]="-refundAmount"
                                />
                            }
                            @if (showAccessoriesInDaily) {
                                <div class="row">
                                    <p class="text is-level-2 has-text-weight-semibold">Mes accesssoires</p>
                                </div>
                                @for (
                                    ticketLine of accessoriesTicketLines | productLineType: 'daily';
                                    let idx = $index;
                                    track ticketLine
                                ) {
                                    @if (!ticketLine.isIncludedPrice) {
                                        <checkout-ticketline
                                            [ticketLine]="ticketLine"
                                            [showPrice]="ticketLine.price > 0 && !commercialProposal?.nbLoan"
                                            [dataTcCategory]="ticketLine?.popover ? 'Cle_4G' : ''"
                                            [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                            labelCheckoutCy="today_ticket_label"
                                        />
                                    }
                                }
                            }

                            <!-- Mobile recovery -->
                            <checkout-mobile-recovery
                                [noButtons]="noButtons"
                                (displayRecoveryEvent)="showRecoveryData($event)"
                            />
                        </div>
                    </div>
                </div>
            }
            <!------------------------------------------------ MONTHLY ------------------------------------------------>
            @if (showMonthly && showDaily) {
                <div class="divider has-background-info-fade"></div>
            }
            @if (showMonthly) {
                <div checkoutCy="cart_monthly" class="rows has-gap-3">
                    <checkout-ticketline
                        [isTitle]="true"
                        [label]="'À payer par mois'"
                        [showPrice]="true"
                        [totalPrice]="totals.monthly.final"
                        priceCheckoutCy="monthly_price"
                        labelCheckoutCy=""
                        [hasPeriod]="true"
                    />
                    <div class="row">
                        <p class="text is-level-2 has-text-weight-semibold">
                            {{ isMixedCart ? 'Mes offres' : 'Mon offre' }}
                        </p>
                    </div>

                    @for (
                        ticketLine of ticketLines | productLineType: 'monthly' : true;
                        let idx = $index;
                        track ticketLine
                    ) {
                        <checkout-ticketline
                            [ticketLine]="ticketLine"
                            [showPrice]="ticketLine.productType === 'promoFoyer' || ticketLine.price > 0"
                            [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                            [labelCheckoutCy]="'ticket_label_' + ticketLine.gencode"
                            [subtitles]="ticketLine.subtitles"
                            [hasPeriod]="true"
                        />
                    }
                    @if (isMixedCart) {
                        <div class="is-flex is-vertical" [ngClass]="{ 'is-order-reversed': isFaiFirst }">
                            <div class="rows has-gap-3">
                                @if (showMobileOptions) {
                                    <div class="row">
                                        <p class="text is-level-2 has-text-weight-semibold">Mes options mobiles</p>
                                        @for (
                                            ticketLine of mixedCartMobileOptions | productLineType: 'monthly';
                                            let idx = $index;
                                            track ticketLine
                                        ) {
                                            <checkout-ticketline
                                                [ticketLine]="ticketLine"
                                                [showPrice]="
                                                    ticketLine.productType === 'promoFoyer' || ticketLine.price > 0
                                                "
                                                [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                                [labelCheckoutCy]="'ticket_label_' + ticketLine.gencode"
                                                [subtitles]="ticketLine.subtitles"
                                                [hasPeriod]="true"
                                            />
                                        }
                                    </div>
                                }
                                @if (showFaiOptions) {
                                    <div class="row">
                                        <p class="text is-level-2 has-text-weight-semibold">Mes options box</p>
                                        @for (
                                            ticketLine of mixedCartFaiOptions | productLineType: 'monthly';
                                            let idx = $index;
                                            track ticketLine
                                        ) {
                                            <checkout-ticketline
                                                [ticketLine]="ticketLine"
                                                [showPrice]="
                                                    ticketLine.productType === 'promoFoyer' || ticketLine.price > 0
                                                "
                                                [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                                [labelCheckoutCy]="'ticket_label_' + ticketLine.gencode"
                                                [subtitles]="ticketLine.subtitles"
                                                [hasPeriod]="true"
                                            />
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    } @else if (showAllOptions) {
                        <p class="text is-level-2 has-text-weight-semibold is-marginless">Mes options</p>
                        @for (
                            ticketLine of optionsTicketLines | productLineType: 'monthly';
                            let idx = $index;
                            track ticketLine
                        ) {
                            <checkout-ticketline
                                [ticketLine]="ticketLine"
                                [showPrice]="ticketLine.productType === 'promoFoyer' || ticketLine.price > 0"
                                [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                [labelCheckoutCy]="'ticket_label_' + ticketLine.gencode"
                                [subtitles]="ticketLine.subtitles"
                                [hasPeriod]="true"
                            />
                        }
                    }
                </div>
            }
            <!------------------------------------------------ REPORTED ------------------------------------------------>
            @if (showReported) {
                <div class="divider has-background-info-fade"></div>
            }
            @if (showReported) {
                <div checkoutCy="cart_reported" class="subscription-prices">
                    <checkout-ticketline
                        [isTitle]="true"
                        [label]="'À payer sur la 1ère facture'"
                        [showPrice]="true"
                        [totalPrice]="totals.reported.final"
                    />
                    <div>
                        @for (ticketLine of ticketLines | productLineType: 'reported'; track ticketLine) {
                            <checkout-ticketline
                                [ticketLine]="ticketLine"
                                [showPrice]="ticketLine.price > 0"
                                [dataTcCategory]="ticketLine?.popover ? 'FMS/FMD' : ''"
                                labelCheckoutCy="reported_ticket_label"
                                priceCheckoutCy="reported_ticket_price"
                            />
                        }
                    </div>
                </div>
            }

            <!------------------------------------------------ FUNDING ------------------------------------------------>
            @if (showFundingPrices) {
                <div class="divider has-background-info-fade"></div>
            }
            @if (showFundingPrices) {
                <div checkoutCy="cart_funding" class="subscription-prices">
                    <div class="rows has-gap-3">
                        <checkout-ticketline
                            [isTitle]="true"
                            [label]="'Financement par mois'"
                            [showPrice]="true"
                            [totalPrice]="commercialProposal?.monthlyAmount || edpTicketLine?.price"
                            [hasPeriod]="true"
                        />
                        <!-- Included Price -->
                        <div class="rows has-gap-2">
                            @for (ticketLine of ticketLines | productLineType: 'daily' : true; track ticketLine) {
                                @if (ticketLine.isIncludedPrice) {
                                    <checkout-ticketline
                                        [ticketLine]="ticketLine"
                                        [showPrice]="ticketLine.price > 0 && !commercialProposal?.nbLoan"
                                        [dataTcCategory]="ticketLine?.popover ? 'Cle_4G' : ''"
                                        [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                        labelCheckoutCy="today_ticket_label"
                                    />
                                }
                            }

                            <!-- Funding -->
                            @if (commercialProposal?.monthlyAmount > 0) {
                                <checkout-ticketline
                                    [label]="'Financement x' + commercialProposal?.nbLoan + ' mois'"
                                    [totalPrice]="commercialProposal?.monthlyAmount"
                                    [showPrice]="true"
                                    [subtitles]="fundingSubtitle"
                                    [hasPeriod]="true"
                                />
                            }
                            <!-- EDP -->
                            @if (edpTicketLine?.label) {
                                <checkout-ticketline
                                    [label]="edpTicketLine?.label"
                                    [totalPrice]="edpTicketLine?.price"
                                    [showPrice]="true"
                                    [hasPeriod]="true"
                                    [subtitles]="[]"
                                />
                            }
                        </div>
                        @if (showAccessoriesInFundings) {
                            <div class="rows has-gap-2">
                                <div class="row">
                                    <p class="text is-level-2 has-text-weight-semibold is-marginless">
                                        Mes accesssoires
                                    </p>
                                </div>
                                @for (
                                    ticketLine of accessoriesTicketLines | productLineType: 'daily';
                                    let idx = $index;
                                    track ticketLine
                                ) {
                                    @if (ticketLine.isIncludedPrice) {
                                        <checkout-ticketline
                                            [ticketLine]="ticketLine"
                                            [showPrice]="ticketLine.price > 0 && !commercialProposal?.nbLoan"
                                            [dataTcCategory]="ticketLine?.popover ? 'Cle_4G' : ''"
                                            [priceCheckoutCy]="'ticket_price_' + ticketLine.gencode"
                                            labelCheckoutCy="today_ticket_label"
                                        />
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            @if (showDividerBeforeCoupon) {
                <div class="divider has-background-info-fade"></div>
            }
            <checkout-coupon />
            @if (!noButtons && (formStatus$ | async); as formData) {
                <div class="mt-2 buttons is-fullwidth">
                    <button
                        [attr.aria-label]="isPreorder ? 'Pré-commander' : validateButtonLabel"
                        checkoutCy="button-validate"
                        [ngClass]="{ 'is-loading': formData.loading }"
                        [disabled]="formData.invalid"
                        class="button is-conversion is-fullwidth"
                        (click)="validate()"
                    >
                        {{ isPreorder ? 'Pré-commander' : validateButtonLabel }}
                    </button>
                </div>
            }
            @if (hasMobileRecovery) {
                <div class="is-unboxed">
                    <div class="divider has-background-info-fade"></div>
                    <div class="has-text-centered">
                        <sup>*</sup>
                        <span class="text is-level-3">Sous réserve de validation</span>
                    </div>
                </div>
            }
        } @else {
            <checkout-ticket-empty />
        }
    </div>
</div>
